import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=c147e754&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=c147e754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c147e754",
  null
  
)

export default component.exports